import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE });

// Attach JWT to every request if available
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("dogaparquet_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Global 401 handler — clear token and bounce to login
api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            const path = window.location.pathname;
            if (path.startsWith("/admin") && path !== "/admin/login") {
                localStorage.removeItem("dogaparquet_token");
                window.location.href = "/admin/login";
            }
        }
        return Promise.reject(err);
    },
);

// Resolve relative upload URLs (returned as /api/uploads/... by backend)
// to absolute URLs against the backend host.
export const resolveAssetUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http://") || path.startsWith("https://")) return path;
    if (path.startsWith("/api/")) {
        return `${process.env.REACT_APP_BACKEND_URL}${path}`;
    }
    return path; // /portfolio/* served by frontend public
};

export const formatApiError = (err, fallback = "Si è verificato un errore. Riprova.") => {
    const detail = err?.response?.data?.detail;
    if (!detail) return fallback;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" · ");
    if (detail?.msg) return detail.msg;
    return fallback;
};
